import { Optional } from '@vimeo/core/types/generic';

// todo: Make decrypt-encrypt injectable

/**
 * Basic encryption for local storage.
 */
export function encrypt(value: string): string {
  return btoa(value);
}

/**
 * Decrypt function for local storage.
 */
export function decrypt(value: string): string {
  return atob(value);
}

/**
 * Parsing function for local storage.
 */
export function parse<T>(value: string, isEncrypted: boolean = true): Optional<T> {
  return JSON.parse(isEncrypted ? decrypt(value) : value);
}

/**
 * Safely get value by key from localstorage.
 * Key and value are encrypted in B64.
 *
 * Note: it is safe getter which skips exceptions when LS is disabled/blocked by security preferences.
 */
export function getFromLocalStorage<T>(key: string, isEncrypted: boolean = true): Optional<T> {
  try {
    const raw: Optional<string> = localStorage?.getItem(isEncrypted ? encrypt(key) : key) || null;

    return raw === null ? null : parse(raw, isEncrypted);
  } catch (error) {
    return null;
  }
}

/**
 * Set value by key from localstorage.
 * Key and value are encrypted in B64.
 *
 * Note: it is safe getter which skips exceptions when LS is disabled/blocked by security preferences.
 */
export function setLocalStorageItem<T>(key: string, value: T): void {
  try {
    localStorage?.setItem(encrypt(key), encrypt(JSON.stringify(value)));
  } catch (error) {
    // Nothing to do here.
  }
}

/**
 * Remove value by key from local storage.
 * Key and value are encrypted in B64.
 */
export function removeLocalStorageItem(key: string): void {
  try {
    localStorage?.removeItem(encrypt(key));
  } catch (error) {
    // Nothing to do here.
  }
}

/**
 * Normally can be changed only by devs/staff users for local machine.
 * todo: Remove in favor of save get with fallback value.
 */
export function getLocalStorageConfigItem<T>(key: string, defaultValue: T): T {
  try {
    const value: Optional<T> = getFromLocalStorage(key, true);
    return value === null ? defaultValue : value;
  } catch (error) {
    return defaultValue;
  }
}
